import api from './api';

export const rewardService = {
  // Get admin rewards list
  getAdminRewards: (params = {}) => api.get('/rewards/admin/list', { params }),

  // Update reward status (admin)
  updateStatus: (rewardId, data) => api.put(`/rewards/admin/${rewardId}/status`, data),
};
